import { Select, SelectProps } from 'bold-ui'
import { ProcedimentoSelectFieldEmptyItem } from 'components/form/field/select/ProcedimentoSelectField/ProcedimentoSelectFieldEmptyItem'
import { DEFAULT_SELECT_PAGE_PARAM, useAsyncQuerySelect } from 'components/form/field/select/useAsyncQuerySelect'
import { ProcedimentoSelectFieldDocument } from 'graphql/hooks.generated'
import {
  GrupoProcedimentoEnum,
  IdentidadeGeneroEnum,
  ProcedimentoSelectFieldQuery,
  ProcedimentoSelectFieldQueryVariables,
  SexoEnum,
  SubGrupoProcedimentoEnum,
  TipoExameEnum,
  TipoProcedimentoEnum,
} from 'graphql/types.generated'

import { ProcedimentoSelectModel } from '../../form/field/select/ProcedimentoSelectField'
import { ProcedimentoSelectFieldItem } from '../../form/field/select/ProcedimentoSelectField/ProcedimentoSelectFieldItem'

export interface ProcedimentoSelectProps extends Omit<SelectProps<ProcedimentoSelectModel>, 'items' | 'itemToString'> {
  tipoExame?: TipoExameEnum
  tipoProcedimento?: TipoProcedimentoEnum
  gruposProcedimento?: GrupoProcedimentoEnum[]
  subGruposProcedimento?: SubGrupoProcedimentoEnum[]
  identidadeGeneroDbEnum?: IdentidadeGeneroEnum
  sexo?: SexoEnum
  dataNascimento?: LocalDate
  dataAtendimento: LocalDate
  filtrarProcedimentosOdonto?: boolean
  loadItemsOnOpen?: boolean
  dataTestId?: string
}

export function ProcedimentoSelect(props: ProcedimentoSelectProps) {
  const {
    loadItemsOnOpen = true,
    tipoExame,
    tipoProcedimento,
    gruposProcedimento,
    subGruposProcedimento,
    identidadeGeneroDbEnum,
    sexo,
    dataNascimento,
    dataAtendimento,
    filtrarProcedimentosOdonto,
    components,
    dataTestId,
    ...rest
  } = props

  const { skipping, selectProps } = useAsyncQuerySelect<
    ProcedimentoSelectModel,
    ProcedimentoSelectFieldQuery,
    ProcedimentoSelectFieldQueryVariables
  >({
    query: ProcedimentoSelectFieldDocument,
    extractItems: (data) => data?.procedimentos?.content,
    variables: (inputString): ProcedimentoSelectFieldQueryVariables => ({
      input: {
        query: inputString,
        pageParams: DEFAULT_SELECT_PAGE_PARAM,
        filtro: {
          tipoExame,
          tipoProcedimento,
          gruposProcedimento,
          subGruposProcedimento,
          sexo: identidadeGeneroDbEnum ? undefined : sexo,
          dataNascimento,
          dataAtendimento,
          filtrarProcedimentosOdonto,
        },
      },
    }),
    skip: (inputString) => (!loadItemsOnOpen ? inputString?.trim()?.length < 2 : undefined),
    debounceTime: 500,
  })

  return (
    <Select<ProcedimentoSelectModel>
      itemToString={itemToString}
      data-testid={dataTestId}
      renderItem={ProcedimentoSelectFieldItem}
      components={{
        EmptyItem: () => ProcedimentoSelectFieldEmptyItem(skipping, loadItemsOnOpen),
        ...components,
      }}
      {...selectProps}
      {...rest}
    />
  )
}

const itemToString = (item: ProcedimentoSelectModel) => item?.descricao
